import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { FC, useMemo } from "react";

import TimeFromNow from "../../../components/TimeFromNow";
import useCurrentUser from "../../../hooks/useCurrentUser";
import { GenericObject } from "../../../types/generic.types";
import { isReceiver } from "../utils";
import TextWithUrl from "./TextWithUrl";

const useStyles = makeStyles((theme) => ({
  shared: {
    minWidth: 50,
    maxWidth: 350,
    padding: theme.spacing(1),
    margin: theme.spacing(0.5),
    borderRadius: "20px 5px",
    overflowWrap: "anywhere",
    boxShadow: "0 2px 4px #c5c5c5",
  },
  sender: {
    background: theme.palette.primary.main,
    color: theme.palette.grey[800],
    alignSelf: "flex-end",
  },
  receiver: {
    background: theme.palette.grey[200],
    color: "#000",
    alignSelf: "flex-start",
  },
  time: {
    fontSize: 10,
    color: theme.palette.grey[500],
    lineHeight: 3,
  },
}));

const Message: FC<MessageProps> = ({ message }) => {
  const classes = useStyles({});
  const { user } = useCurrentUser();

  const isReceivedMessage = useMemo(() => isReceiver(message, user.id as string), [message, user.id]);

  return (
    <Box display="flex" alignItems="flex-end" flexDirection={isReceivedMessage ? "row" : "row-reverse"}>
      <Box
        className={clsx([
          classes.shared,
          {
            [classes.receiver]: isReceivedMessage,
            [classes.sender]: !isReceivedMessage,
          },
        ])}
      >
        {message.attachment ? (
          <Box maxWidth={225} maxHeight={120} borderRadius={5} overflow="hidden">
            <img
              loading="lazy"
              src={message.attachment.src}
              alt={message.attachment.path}
              style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "cover", cursor: "pointer" }}
              onClick={() => window.open(message.attachment.src, "_blank")}
            />
          </Box>
        ) : (
          <TextWithUrl text={message.text} isReceivedMessage={isReceivedMessage} />
        )}
      </Box>
      <TimeFromNow createdAt={message.createdAt ? message.createdAt.toDate() : new Date()} />
    </Box>
  );
};

interface MessageProps {
  message: GenericObject;
}

export default Message;
